export const LiveStreamEnded = () => {
  return (
    <div className="bg-surface-overlay-80 p2-regular flex h-full w-full items-center justify-center rounded-xl text-white">
      This livestream has ended
    </div>
  );
};
